import { render, staticRenderFns } from "./withdrawal-record.vue?vue&type=template&id=78e7bfa4&scoped=true&"
import script from "./withdrawal-record.vue?vue&type=script&lang=js&"
export * from "./withdrawal-record.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-record.vue?vue&type=style&index=0&id=78e7bfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e7bfa4",
  null
  
)

export default component.exports